document.addEventListener("DOMContentLoaded", () => {
    function initializeCustomSelects(container) {
        const selects = container.querySelectorAll("select");

        selects.forEach((select) => {
            if (select.closest(".custom-select-wrapper")) return; // Prevent duplicate initialization

            // Create wrapper
            const wrapper = document.createElement("div");
            wrapper.classList.add("custom-select-wrapper");
            select.parentNode.insertBefore(wrapper, select);
            wrapper.appendChild(select);

            // Create custom dropdown
            const customSelect = document.createElement("div");
            customSelect.classList.add("custom-select");
            wrapper.appendChild(customSelect);

            // Display selected option
            const selectedOption = document.createElement("div");
            selectedOption.classList.add("custom-selected");
            selectedOption.textContent = select.options[select.selectedIndex].text;
            customSelect.appendChild(selectedOption);

            // Add the SVG arrow icon (use your actual SVG content here)
            const svgIcon = document.createElement("div");
            svgIcon.classList.add("custom-select-arrow");
            svgIcon.innerHTML = `
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.8">
                        <path d="M15.0233 7.14828L9.39828 12.7733C9.34604 12.8256 9.284 12.8671 9.21572 12.8954C9.14743 12.9237 9.07423 12.9383 9.00031 12.9383C8.92639 12.9383 8.8532 12.9237 8.78491 12.8954C8.71662 12.8671 8.65458 12.8256 8.60234 12.7733L2.97734 7.14828C2.8718 7.04273 2.8125 6.89958 2.8125 6.75031C2.8125 6.60105 2.8718 6.45789 2.97734 6.35234C3.08289 6.2468 3.22605 6.1875 3.37531 6.1875C3.52458 6.1875 3.66773 6.2468 3.77328 6.35234L9.00031 11.5801L14.2273 6.35234C14.2796 6.30008 14.3417 6.25863 14.4099 6.23034C14.4782 6.20206 14.5514 6.1875 14.6253 6.1875C14.6992 6.1875 14.7724 6.20206 14.8407 6.23034C14.909 6.25863 14.971 6.30008 15.0233 6.35234C15.0755 6.40461 15.117 6.46665 15.1453 6.53493C15.1736 6.60322 15.1881 6.6764 15.1881 6.75031C15.1881 6.82422 15.1736 6.89741 15.1453 6.96569C15.117 7.03398 15.0755 7.09602 15.0233 7.14828Z" fill="#525B67"/>
                    </g>
                </svg>
            `;
            customSelect.appendChild(svgIcon);

            // Dropdown list
            const optionList = document.createElement("div");
            optionList.classList.add("custom-options");
            wrapper.appendChild(optionList);

            // Populate options
            Array.from(select.options).forEach((option, index) => {
                if (index === 0) return; // Skip placeholder
                const optionItem = document.createElement("div");
                optionItem.classList.add("custom-option");
                optionItem.textContent = option.text;
                optionItem.dataset.value = option.value;
                optionList.appendChild(optionItem);

                // Handle selection
                optionItem.addEventListener("click", () => {
                    select.value = optionItem.dataset.value;
                    selectedOption.textContent = optionItem.textContent;
                    optionList.classList.remove("show");
                    svgIcon.classList.remove("rotate");
                    select.dispatchEvent(new Event("change"));
                });
            });

            // Toggle dropdown
            selectedOption.addEventListener("click", (event) => {
                event.stopPropagation(); // Prevent immediate closing
                document.querySelectorAll(".custom-options").forEach((list) => {
                    if (list !== optionList) list.classList.remove("show");
                });
                optionList.classList.toggle("show");

                // Rotate the arrow when opening and closing
                svgIcon.classList.toggle("rotate");
            });

            // Close dropdown when clicking outside
            document.addEventListener("click", (e) => {
                if (!wrapper.contains(e.target)) {
                    optionList.classList.remove("show");
                    svgIcon.classList.remove("rotate");
                }
            });

            // Hide original select
            select.style.display = "none";
        });
    }

    function initializeForms() {
        document.querySelectorAll(".wpcf7-form").forEach((form) => {
            initializeCustomSelects(form);

            form.addEventListener("wpcf7mailsent", () => {
                console.log("Form submitted successfully!");
                initializeCustomSelects(form); // Reinitialize after form submission
            });

            form.addEventListener("wpcf7invalid", () => {
                console.log("Form validation failed.");
            });
        });
    }

    // Run on page load
    initializeForms();

    // Reinitialize on AJAX updates
    document.addEventListener("wpcf7submit", () => {
        setTimeout(() => {
            initializeForms();
        }, 500);
    });
});
